import { Injectable } from '@angular/core';
import { OpenApiDataSource, RxapOpenApiDataSource } from 'eurogard-open-api-data-source';
import { OptionsControllerGetEnumAlarmStatusTypeResponse } from '../responses/options-controller-get-enum-alarm-status-type.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiDataSource('options-controller-getEnumAlarmStatusType')
export class OptionsControllerGetEnumAlarmStatusTypeDataSource extends OpenApiDataSource<OptionsControllerGetEnumAlarmStatusTypeResponse, void> {
}
